import { Fragment, useState } from "react";
import {
  StyledAvatar,
  StyledTypography,
  StyledarticlePic,
  StyledAccordionSummary,
} from "./NewsCard.style";
import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ImgContainer from "components/shared/Image";
import { IMG_BASE_URL } from "constants";
import parse from "html-react-parser";

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

export default function NewsCard(props) {
  // const [expanded, setExpanded] = useState(false);

  // const handleExpandClick = () => {
  //   setExpanded(!expanded);
  // };

  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Fragment>
      {props.rows.map((row, index) => {
        return (
          <Grid item lg={4} md={4} sm={6} xs={12} key={"row" + row.id}>
            <Card>
              <CardHeader
                avatar={
                  <StyledAvatar aria-label="recipe">{index + 1}</StyledAvatar>
                }
                subheader={row.created_at?.string}
              />
              <StyledarticlePic>
                {row.file_type == "image" ? (
                  <img src={IMG_BASE_URL + row?.file} alt={"مقاله" + index} />
                ) : (
                  <video src={IMG_BASE_URL + row?.file} controls></video>
                )}
              </StyledarticlePic>

              <CardContent>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ textAlign: "justify" }}
                >
                  {row.title}
                </Typography>
              </CardContent>
              <Accordion
                expanded={expanded === `"panel" + ${row.id}`}
                onChange={handleChange(`"panel" + ${row.id}`)}
              >
                <StyledAccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4bh-content"
                  id="panel4bh-header"
                >
                  <div
                    onClick={() => (props.click ? props.click(row.id) : null)}
                  >
                    <IconButton aria-label="ویرایش">
                      <EditIcon />
                    </IconButton>
                  </div>
                </StyledAccordionSummary>
                <AccordionDetails>
                  <StyledTypography>{parse(row.text)}</StyledTypography>
                </AccordionDetails>
              </Accordion>
            </Card>
          </Grid>
        );
      })}
    </Fragment>
  );
}
